import { ADMISSION_OFFERS_ERROR, GETTING_ADMISSION_OFFERS, GET_ADMISSION_OFFERS } from "../types"


const initialState = {
    admissionOffers: [],
    loadingAdmissionOffers: true,
    admissionOffersError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_ADMISSION_OFFERS:
        return {
            ...state,
            loadingAdmissionOffers :action.payload,
        }
        case GET_ADMISSION_OFFERS:
        return{
            ...state,
            loadingAdmissionOffers:false,
            admissionOffersError:  null,
            admissionOffers: action.payload,
        }
        case ADMISSION_OFFERS_ERROR:
        return{
            ...state,
            loadingAdmissions:false,
            admissionOffersError: action.payload 
        }

        default: return state
    }

}